module.exports = {
    ASK_QUESTION: 'ASK_QUESTION',
    SEND_ANSWER_RESULTS: 'SEND_ANSWER_RESULTS',
    GIVE_ME_IMPROVISERS_LIST: 'GIVE_ME_IMPROVISERS_LIST',
    DELETE_ALL_USER: 'DELETE_ALL_USER',
    LAUNCH_DICE:'LAUNCH_DICE',
    RESET_RESULT:'RESET_RESULT',
    GET_DICE_RESULT:'GET_DICE_RESULT',
    LAUNCH_QUESTION:'LAUNCH_QUESTION',
    LAUNCH_CHOICE: 'LAUNCH_CHOICE',
    LAUNCH_TWO_WORDS:'LAUNCH_TWO_WORDS',
    LAUNCH_VOTATION:'LAUNCH_VOTATION',
    LAUNCH_VOTATION_AMAGGIORANZA:'LAUNCH_VOTATION_AMAGGIORANZA',
    LAUNCH_SEVEN_WORDS: 'LAUNCH_SEVEN_WORDS',
    LAUNCH_SONG:'LAUNCH SONG',
    SEND_RESULT: 'SEND_RESULT',
    VOTED: 'VOTED',
    VOTED_AMAGGIORANZA: 'VOTED_AMAGGIORANZA',
    CHOICED: 'CHOICED',
    CHECK_INTEGRITY: 'CHECK_INTEGRITY',
    INITIATE_DB: 'INITIATE_DB',
    END_GAME: 'END_GAME',
    WAIT_TO_END: 'WAIT_TO_END',
    TWO_WORDS_ENDED:'TWO_WORDS_ENDED'
}


// WEBPACK FOOTER //
// ./src/events/DashboardToServer.js